var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useMemo } from 'react';
import { useGetHasGroupAccess } from '../../../hooks/LMSGroups/hasGroupAccess';
import AddBlock from './addblock';
import useCommonProps from '../../../hooks/useCommonProps';
import { getAdditionalInfoVal } from '../../../utilites/getAdditionalInfoVal';
export var ConditionalBlockWithAddWrapper = function (_a) {
    var draggableProps = _a.draggableProps, addBlockProps = _a.addBlockProps, children = _a.children, post = _a.post;
    var isEditable = useCommonProps().isEditable;
    var activeGroups = useMemo(function () {
        return JSON.parse(getAdditionalInfoVal(post === null || post === void 0 ? void 0 : post.additionalInfo, 'activeGroups') || '[]');
    }, [post]);
    var hasGroupAccess = useGetHasGroupAccess(activeGroups || [], true);
    if (!hasGroupAccess)
        return null;
    return (React.createElement("div", __assign({}, draggableProps),
        isEditable && React.createElement(AddBlock, __assign({}, addBlockProps)),
        children));
};
//# sourceMappingURL=ConditionalBlockWithAddWrapper.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useMemo } from 'react';
import { useGetHasGroupAccess } from '../../../hooks/LMSGroups/hasGroupAccess';
import AddBlock from './addblock';
import useCommonProps from '../../../hooks/useCommonProps';
import { getAdditionalInfoVal } from '../../../utilites/getAdditionalInfoVal';
export var ConditionalBlockWithAddWrapper = function (_a) {
    var draggableProps = _a.draggableProps, addBlockProps = _a.addBlockProps, children = _a.children, post = _a.post;
    var isEditable = useCommonProps().isEditable;
    var activeGroups = useMemo(function () {
        return JSON.parse(getAdditionalInfoVal(post === null || post === void 0 ? void 0 : post.additionalInfo, 'activeGroups') || '[]');
    }, [post]);
    var hasGroupAccess = useGetHasGroupAccess(activeGroups || [], true);
    if (!hasGroupAccess)
        return null;
    return (React.createElement("div", __assign({}, draggableProps),
        isEditable && React.createElement(AddBlock, __assign({}, addBlockProps)),
        children));
};
//# sourceMappingURL=ConditionalBlockWithAddWrapper.js.map